"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _RadioGroupContext = _interopRequireDefault(require("./RadioGroupContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useRadioControl = function useRadioControl(_ref) {
  var radioValue = _ref.radioValue,
    onChangeProp = _ref.onChange;
  var _useContext = (0, _react.useContext)(_RadioGroupContext["default"]),
    value = _useContext.value,
    onGroupChange = _useContext.onChange;
  var handleChange = (0, _react.useCallback)(function (event) {
    onGroupChange(event, radioValue);
    if (onChangeProp) {
      onChangeProp(event, radioValue);
    }
  }, [onGroupChange, onChangeProp]);
  return {
    checked: value === radioValue,
    onChange: handleChange
  };
};
var _default = exports["default"] = useRadioControl;